import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { QBOEnvironment } from 'src/environments/environment';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus } from '../../enum';

@Component({
  selector: 'app-add-update-deposit',
  templateUrl: './add-update-deposit.component.html',
  styleUrls: ['./add-update-deposit.component.scss'],

  standalone: false,
})
export class AddUpdateDepositComponent {
  isVisibleDepositModal: any = true;
  isLoadingPrograms: any = false;
  isLoadingDeposit: any = false;
  isLoadingTags: any = false;
  isDepositSkeleton: any = false;
  listOfProgramPeriods: any;
  qboOriginalbillLink: any = null;
  getDepositDetail: any;
  isResyncingData: boolean = false;
  selectedTag: any;
  @Output() hideDepositDrawer = new EventEmitter();
  @Input() selectedData: any;
  selectedTagGroup: any = '';
  listOfTags: any[] = [];
  listOfUnfilteredTags: any[] = [];
  qboURL = QBOEnvironment.URL;
  depositCheckNum: any;
  siteDetails: any;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.expenseForm_fb();
  }
  ngOnInit(): void {
    this.getDepositDetails();
  }

  handleCancel(data: any) {
    this.isVisibleDepositModal = false;
    this.hideDepositDrawer.emit({
      hide: this.isVisibleDepositModal,
      data: data,
    });
  }
  resynDepositData() {
    this.isResyncingData = true;
    this._cpS
      .resyncDepositData(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isDepositDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this.isResyncingData = false;
            this.getDepositDetail = response.result;
            this._cS.displayMessage('success', response.message);
          }
        } else {
          this.isResyncingData = false;
          this._cS.displayMessage('error', response.message);
        }
      });
  }
  getDepositDetails() {
    this.isDepositSkeleton = true;
    this._cpS
      .GetDepositDetail(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.getDepositDetail = response.result;
          this.depositCheckNum = this.getDepositDetail.depositCheckNum;
          this._fS.expenseForm.patchValue({
            programPeriod: this.getDepositDetail?.program?.id,
            tags: this.getDepositDetail?.tag?.id,
            isNonAlc: this.getDepositDetail?.isNonALC,
          });
          this.getTags();
          this.loadPrograms();
          this.getSiteDetails();
          this.isDepositSkeleton = false;
        }
      });
  }
  getSiteDetails() {
    this._cpS
      .GetSiteDetails(this.getDepositDetail.siteId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.siteDetails = response.result;
        }
      });
  }
  loadPrograms() {
    this.isLoadingPrograms = true;
    this._cpS.getProgramBySite(this.getDepositDetail.siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isLoadingPrograms = false;
          this.listOfProgramPeriods = response.result;
          var defaultProgram = this.listOfProgramPeriods.find(
            (x: any) => x?.isDefault
          );
          if (this.selectedData == null) {
            this._fS.expenseForm.patchValue({
              programPeriod: defaultProgram?.id,
            });
          }
        } else {
          this.listOfProgramPeriods = [];
          this.isLoadingPrograms = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.listOfProgramPeriods = [];
        this.isLoadingPrograms = false;
      }
    );
  }

  searchTagGroupAndTags(searchTerm) {
    // Make the search term case insensitive
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const result = this.listOfTags
      .map((item) => {
        // Check if the event's Name matches the search term
        const isNameMatch =
          item.Name.toLowerCase().includes(lowerCaseSearchTerm);

        // Filter the tags that match the search term
        const matchingTags = item.Tags.filter((tag) =>
          tag.Name.toLowerCase().includes(lowerCaseSearchTerm)
        );

        // If the event name matches, include the whole item with all tags
        if (isNameMatch) {
          return {
            ...item,
            Tags: item.Tags,
          };
        }

        // If there are matching tags, include the item with only those tags
        if (matchingTags.length > 0) {
          return {
            ...item,
            Tags: matchingTags,
          };
        }

        // Otherwise, exclude this item
        return null;
      })
      .filter((item) => item !== null);

    // Output the result
    return result;
  }

  returnFilteredTags(searchTerm) {
    if (searchTerm) {
      const filteredResult = this.searchTagGroupAndTags(searchTerm);
      this.listOfTags = filteredResult;
    } else {
      this.listOfTags = this.listOfUnfilteredTags;
    }
  }

  getTags() {
    this.isLoadingTags = true;
    this._cpS.getTagsDropdownList(this.getDepositDetail.siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfTags = response.result;
          this.listOfUnfilteredTags = JSON.parse(JSON.stringify(response.result));
          this.checkTagGroupData(this.getDepositDetail?.tag?.id);
          this.isLoadingTags = false;
        } else {
          this.isLoadingTags = false;
          this._cS.displayMessage('error', response.message);
          this.listOfTags = [];
        }
      },
      (error: any) => {
        this.isLoadingTags = false;
        this.listOfTags = [];
      }
    );
  }

  checkTagGroupData(event: any) {
    var selectedGroup: any;
    var selectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          selectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroup = selectedGroup;
    this.selectedTag = selectedTag?.Name;
  }

  updateDeposit() {
    if (this._fS.expenseForm.valid) {
      this.isLoadingDeposit = true;
      var formValueDeposit = this._fS.expenseForm.value;

      var selectedProgram = this.listOfProgramPeriods.find(
        (x: any) => x.id == formValueDeposit.programPeriod
      );
      var DepositData = {
        id: this.selectedData.id,
        program: {
          id: formValueDeposit.programPeriod,
          name: selectedProgram.label,
        },
        tag: {
          id: formValueDeposit.tags,
          name: this.selectedTag,
        },
        isNonAlc: formValueDeposit.isNonAlc,
      };
      this._cpS.updateDeposit(DepositData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide deposit drawer
          this.isVisibleDepositModal = false;
          this.hideDepositDrawer.emit({
            hide: this.isVisibleDepositModal,
            data: null,
          });
          this.isLoadingDeposit = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingDeposit = false;
        }
      });
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.expenseForm);
    }
  }
}
